export default __webpack_public_path__ + "static/media/file-cad-regular-full.48d99ead.svg";